import { gql } from '@apollo/client';
/**
 * @fragment EntityReminderFragment
 * @since 1.0.0
 */
export const EntityReminderFragment = gql `
  fragment EntityReminderFragment on EntityReminder {
    id
    entity
    entityId
    entityLabel
    content
    dueAt
    completedAt
    author {
      id
      fullname
      firstname
      image {
        url
      }
    }
    createdAt
    updatedAt
  }
`;
